import styled, { css } from 'styled-components';
import { Box, Button } from '@bechtel/gds';
import { headerColumnWidth } from './matrix/styled';

export const PermissionContainerStyled = styled(Box).attrs({
  mt: { sm: '400' },
  ml: { sm: '400' },
  mr: { sm: '300' },
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[200]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  position: relative;
  height: 100vh;
  overflow: hidden;
`;
export const PermissionFooterStyled = styled(Box).attrs({
  py: { sm: '500' },
  pr: { sm: '500' },
  justifyContent: { sm: 'flex-end' },
})`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;

export const FreezeCellStyled = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: ${theme.spacings[900]};
    left: 0;
    width: ${headerColumnWidth};
    height: ${theme.spacings[800]};
    background-color: ${theme.colors.grey[200]};
    border-right: solid 1px ${theme.colors.grey[300]};
  `}
`;
